import React from 'react'
import { Section } from '../Section'

export default function Contact() {

  return (
    <div className="tw-bg-tertiary">
      <Section className="tw-flex md:tw-items-center tw-flex-col md:tw-flex-row tw-gap-8 md:tw-gap-16">
        <div className="tw-flex-1">
          <h3>Have any more questions?</h3>
          <p>If your account was restricted or closed  or you want to know how wo avoid this from happening. Contact our support center.</p>
        </div>

        <div className="tw-space-y-2">
          <p>Mon- Fri 5AM - 6PM</p>
          <p className="tw-flex tw-items-center tw-gap-2">
            <img
              src="/assets/images/icons/call.png"
              alt="Contact POD"
              width={24}
              height={24}
              className="size-24px"
            />
            <a href="tel:+2342039666614">+ 234 (203) 966 6614</a>
          </p>
          <p className="tw-flex tw-items-center tw-gap-2">
            <img
              src="/assets/images/icons/messages.png"
              alt="Contact POD"
              width={24}
              height={24}
              className="size-24px"
            />
            <a href="mailto:support@payondelivery.com">support@payondelivery.com</a>
          </p>
        </div>
      </Section>
    </div>
  )
}
